// export const BASE_URL = "https://projectbeatrecords.in:8811"

export const BASE_URL = "https://api.projectbeatrecords.in"





// export const BASE_URL = "https://192.168.1.9:8811"
